import { LoginFormValues } from './'

export const validateLoginForm = (values: LoginFormValues) => {
  const errors: Partial<LoginFormValues> = {}
  if (!values.email) {
    errors.email = 'Campo richiesto'
  }

  if (!values.password) {
    errors.password = 'Campo richiesto'
  }

  return errors
}
